"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomersStore = void 0;
/* eslint-disable no-useless-catch */
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useCustomersStore = (0, pinia_1.defineStore)("customers", {
    state: () => ({
        loading: false,
        customers: [],
        customerGroups: [],
        currentCustomer: null,
        totalCustomers: 0
    }),
    actions: {
        async getCustomers(router, params = {}) {
            this.loading = true;
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "customers_api", query: params }).href);
                const customers = [];
                if (Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] === 'Customer') {
                            customers.push(element);
                        }
                    });
                }
                this.customers = customers;
                this.totalCustomers = response['hydra:totalItems'] || customers.length;
                this.loading = false;
                return customers;
            }
            catch (error) {
                this.loading = false;
                throw error;
            }
        },
        async getCustomer(router, id) {
            this.loading = true;
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "customers_api", params: { id } }).href);
                this.loading = false;
                this.currentCustomer = response;
                return response;
            }
            catch (error) {
                this.loading = false;
                throw error;
            }
        },
        async getCustomerInfo(router, id) {
            this.loading = true;
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "customers_api_info", params: { id } }).href);
                this.loading = false;
                return response;
            }
            catch (error) {
                this.loading = false;
                throw error;
            }
        },
        async getCustomerGroups(router, params = {}) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "customers_api_customer_groups", query: params }).href);
                this.customerGroups = response;
                return response;
            }
            catch (error) {
                throw error;
            }
        },
        async importCustomer(router, payload) {
            try {
                const options = { body: JSON.stringify(payload), method: "POST" };
                const response = await (0, fetch_1.default)(router.resolve({ name: "customers_api_import_customer" }).href, options);
                return response;
            }
            catch (error) {
                throw error;
            }
        },
        reset() {
            this.loading = false;
            this.customers = [];
            this.customerGroups = [];
            this.currentCustomer = null;
            this.totalCustomers = 0;
        }
    }
});
